var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileDrugIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.668 4.60156H17.418V3.85156C17.4168 3.45409 17.2584 3.07323 16.9774 2.79217C16.6963 2.51111 16.3154 2.35271 15.918 2.35156H9.91797C9.5205 2.35271 9.13963 2.51111 8.85858 2.79217C8.57752 3.07323 8.41912 3.45409 8.41797 3.85156V4.60156H6.16797C5.7705 4.60271 5.38963 4.76111 5.10858 5.04217C4.82752 5.32323 4.66912 5.70409 4.66797 6.10156V21.8516C4.66912 22.249 4.82752 22.6299 5.10858 22.911C5.38963 23.192 5.7705 23.3504 6.16797 23.3516H11.418V21.8516H6.16797V6.10156H8.41797V8.35156H17.418V6.10156H19.668V9.85156H21.168V6.10156C21.1668 5.70409 21.0084 5.32323 20.7274 5.04217C20.4463 4.76111 20.0654 4.60271 19.668 4.60156ZM15.918 6.85156H9.91797V3.85156H15.918V6.85156ZM18.3627 16.5695L19.9537 18.1605C20.7348 18.9415 20.7348 20.2078 19.9537 20.9889C19.1727 21.7699 17.9064 21.7699 17.1253 20.9889L15.5343 19.3979L18.3627 16.5695ZM17.3021 15.5088L15.7111 13.9178C14.93 13.1368 13.6637 13.1368 12.8827 13.9178C12.1016 14.6989 12.1016 15.9652 12.8827 16.7462L14.4737 18.3372L17.3021 15.5088ZM11.822 17.8069C10.4552 16.4401 10.4552 14.224 11.822 12.8572C13.1888 11.4903 15.4049 11.4903 16.7717 12.8572L21.0144 17.0998C22.3812 18.4666 22.3812 20.6827 21.0144 22.0495C19.6476 23.4164 17.4315 23.4164 16.0646 22.0495L11.822 17.8069Z",
    fill: "#0F1011"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDrugIcon);
export default __webpack_public_path__ + "static/media/file-drug-icon.e04389644a498d8a9ee828854a5827aa.svg";
export { ForwardRef as ReactComponent };